import {
    createTheme
} from '@mui/material/styles';
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 540,
            md: 720,
            lg: 960,
            xl: 1140
        },
    },
    palette: {
        background: {
            default: '#FFFFFF',
        }
    },
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: "xl"
            }
        },
        MuiTypography: {
            styleOverrides: {
                body1: {
                    lineHeight: "20px",
                    fontSize: "14px"
                }
            }
        }
    },
    typography:{
        allVariants:{
            color: "#2b2b2b",
            fontFamily: ['"Visuelt Pro"',"Helvetica", "Arial", "Roboto","sans-serif"].join(',')
        },
        fontFamily: ['"Visuelt Pro"',"Helvetica", "Arial", "Roboto","sans-serif"].join(',')
    }
});

theme.typography.h1 = {
    ...theme.typography.h1,
    lineHeight: "49px",
    fontSize: "40px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '40px',
        lineHeight: "49px"
    }
}

theme.typography.h2 = {
    ...theme.typography.h2,
    lineHeight: "37px",
    fontSize: "30px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '45px',
        lineHeight: "55px"
    }
}

theme.typography.h3 = {
    ...theme.typography.h3,
    lineHeight: "31px",
    fontSize: "24px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '35px',
        lineHeight: "42px"
    }
}
theme.typography.h4 = {
    ...theme.typography.h4,
    lineHeight: "26px",
    fontSize: "20px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '25px',
        lineHeight: "30px"
    }
}
theme.typography.subtitle2={
    ...theme.typography.subtitle2,
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
        fontSize: '18px',
        lineHeight: "22px"
    }
}


export default theme;